import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Container, Button, Row, Col, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { LOW_INVENTORY_RESET } from '../constants/reportConstants'
import { ThemeContext } from '../components/ThemeContext.js'
import {
  EMPLOYEE_PERMISSIONS,
  hasEmployeePermission
} from '../constants/employeePermissions.js'

const InventoryReports = () => {
  // get all inventory
  // find low inventory items
  // display list sorted by manufacturer

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { theme } = useContext(ThemeContext)

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const canViewReports = hasEmployeePermission(
    userInfo,
    ownerInfo,
    EMPLOYEE_PERMISSIONS.REPORTS_VIEW
  )

  useEffect(() => {
    if (!userInfo && !ownerInfo) {
      dispatch({ type: LOW_INVENTORY_RESET })
      navigate('/login')
    } else if (!canViewReports) {
      navigate('/pos')
    }
  }, [dispatch, navigate, userInfo, ownerInfo, canViewReports])

  return (
    <Container className='my-3 report-page' style={{ color: theme.text }}>
      <div className='report-page-heading'>
        <h1>Reports</h1>
        <p>Review sales performance and inventory activity.</p>
      </div>
      <Row className='g-3 report-link-grid'>
        {[
          {
            path: '/reports/lowinventory',
            title: 'Low inventory',
            description: 'Find products at or below their stock threshold.'
          },
          {
            path: '/reports/sales',
            title: 'Sales summary',
            description: 'Review sales totals, trends, and top sellers.'
          },
          {
            path: '/reports/salesdetail',
            title: 'Sales transactions',
            description: 'Inspect individual sales, returns, and line items.'
          },
          {
            path: '/reports/stockmovements',
            title: 'Inventory adjustments',
            description: 'Track changes to stock quantities over time.'
          }
        ].map((report) => (
          <Col key={report.path} xs={12} sm={6}>
            <Link to={report.path} className='report-link-card'>
              <Card
                className='h-100'
                style={{
                  backgroundColor: theme.card,
                  color: theme.text,
                  borderColor: theme.surfaceMuted
                }}
              >
                <Card.Body>
                  <Card.Title>{report.title}</Card.Title>
                  <Card.Text style={{ color: theme.subtext }}>
                    {report.description}
                  </Card.Text>
                  <span className='report-link-action'>Open report →</span>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
      <Button
        size='sm'
        variant='outline-primary'
        className='my-3'
        onClick={() => navigate('/inventory')}
      >
        To Inventory
      </Button>
    </Container>
  )
}

export default InventoryReports
